class DataBin
{
    /**
     * Creates data bin with a given size and offset
     * @param {number} size - size of the bin, cannot be negative
     * @param {number} offset - offset from 0
     */
    constructor(size, offset) {
        if (Number.isNaN(size)) {
            throw new TypeError('size must be an number');
        }

        if (Number.isNaN(offset)) {
            throw new TypeError('offset must be an number');
        }

        if (size < 0) {
            throw new Error('size must be greater than zero');
        }

        this.size = size;
        this.offset = offset;

        this.data = [];
    }
    
    /**
     * Allows to add new value to the bin
     * @param {Number} value 
     */
    add(value) {
        this.data.push(value);
    }

    /**
     * Returns a copy of values assigned to this bin
     * @returns {Array}
     */
    getValues() {
        return this.data.concat([]);
    }

    /**
     * Returns smallest value allowed for this bin (inclusive)
     * @returns {Number}
     */
    fromWhere() {
        return this.offset;
    }

    /**
     * Returns biggest value allowed for this bin (exclusive)
     * @returns {Number}
     */
    toWhere() {
        return this.offset + this.size;
    }

    center() {
        return this.offset + this.size / 2;
    }
}

export default DataBin;